import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { postFimarActa } from '../../../../../../appStore/actas';
import Form from '../../../../../CompUtils/Form';
const Root = styled.div`
  max-width: 400px;
`;

const HorizontalDiv = styled.div`
  display: flex;
  justify-content: end;
`;

const TopMargin = styled.div`
  margin-top: -24px;
`;

type Props = { idFirmaActa: number; onClose: () => void };
export const FirmaBajoConformidad = (props: Props) => {
  const { idFirmaActa, onClose } = props;
  const dipatch = useDispatch();
  return (
    <Root>
      <Form
        disableBtns={idFirmaActa === 0}
        submitText="Firmar acta"
        onSubmit={(valores: any) => {
          dipatch(postFimarActa({ idFirmaActa, ...valores }));
          onClose();
        }}
        btns={[]}>
        <div>
          <p>Para continuar hagá click en Firmar acta</p>
          {/* <HorizontalDiv>
            <small>
              Firmar el acta en <b>disconformidad</b>?
            </small>
            <RadioInput isCheckbox id="firmaDisconformidad" />
          </HorizontalDiv>
          <TopMargin>
            <TextInput
              multiline
              hide={({ firmaDisconformidad }) => !firmaDisconformidad}
              title="Motivo de disconformidad"
              id="motivoDisconformidad"
            />
          </TopMargin> */}
        </div>
      </Form>
    </Root>
  );
};
